import cliffMarketService from '@/services/cliff-market.service';

const initialState = {
    status: {
        listOrdersComplete: false,
        getOrderComplete: false,
        listCustomersComplete: false,
        getCustomerComplete: false,
        updateCustomerComplete: false,
        updatePaymentStateComplete: false,
        updateCustomerGroupComplete: false
    },
    orders: [],
    order: {},
    customers: [],
    customer: {},
    updateCustomer: {},
    updatePaymentState: {},
    updateCustomerGroup: {}
};

export const cliffMarketModule = {
    namespaced: true,
    state: initialState,
    actions: {
        clearOrders({ commit }) {
            commit('clearOrders');
        },
        listOrders({ dispatch, commit }, payload) {
            return new Promise((resolve, reject) => {
                cliffMarketService.listOrders(payload.page, payload.limit, payload.sort, payload.term)
                    .then(orders => {
                        commit('populateOrders', orders);
                        resolve(orders);
                    })
                    .catch(error => {
                        commit('clearOrders');
                        dispatch('alert/error', error, { root: true });
                        reject(error);
                    });
            });
        },
        clearOrder({ commit }) {
            commit('clearOrder');
        },
        getOrder({ commit, dispatch }, orderNumber) {
            return new Promise((resolve, reject) => {
                commit('clearOrder');
                cliffMarketService.getOrder(orderNumber)
                    .then(order => {
                        commit('populateOrder', order);
                        resolve(order);
                    })
                    .catch(error => {
                        commit('clearOrder');
                        dispatch('alert/error', error, { root: true });
                        reject(error);
                    });
            });
        },
        clearCustomers({ commit }) {
            commit('clearCustomers');
        },
        listCustomers({ dispatch, commit }, payload) {
            return new Promise((resolve, reject) => {
                cliffMarketService.listCustomers(payload.page, payload.limit, payload.filter)
                    .then(customers => {
                        commit('populateCustomers', customers);
                        resolve(customers);
                    })
                    .catch(error => {
                        commit('clearCustomers');
                        dispatch('alert/error', error, { root: true });
                        reject(error);
                    });
            });

        },
        clearCustomer({ commit }) {
            commit('clearCustomer');
        },
        getCustomer({ commit, dispatch }, customerId) {
            return new Promise((resolve, reject) => {
                commit('clearCustomer');
                cliffMarketService.getCustomer(customerId)
                    .then(customer => {
                        commit('populateCustomer', customer);
                        resolve(customer);
                    })
                    .catch(error => {
                        commit('clearCustomer');
                        dispatch('alert/error', error, { root: true });
                        reject(error);
                    });
            });
        },
        clearUpdateCustomer({ commit }) {
            commit('clearUpdateCustomer');
        },
        updateCustomer({ dispatch, commit }, customer) {
            return new Promise((resolve, reject) => {
                commit('clearUpdateCustomer');
                cliffMarketService.updateCustomer(customer)
                    .then(updatedCustomer => {
                        commit('populateUpdateCustomer', updatedCustomer);
                        resolve();
                    })
                    .catch(error => {
                        commit('clearUpdateCustomer');
                        dispatch('alert/error', error, { root: true });
                        reject(error);
                    });
            });
        },
        clearUpdatePaymentState({ commit }) {
            commit('clearUpdatePaymentState');
        },
        updatePaymentState({ dispatch, commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('clearUpdatePaymentState');
                cliffMarketService.updatePaymentState(payload.order, payload.state)
                    .then(updatedPaymentState => {
                        commit('populateUpdatePaymentState', updatedPaymentState);
                        resolve(updatedPaymentState);
                    })
                    .catch(error => {
                        commit('clearUpdatePaymentState');
                        dispatch('alert/error', error, { root: true });
                        reject(error);
                    });
            });
        },
        clearUpdateCustomerGroup({ commit }) {
            commit('clearUpdateCustomerGroup');
        },
        updateCustomerGroup({ dispatch, commit }, payload) {
            return new Promise((resolve, reject) => {
                commit('clearUpdateCustomerGroup');
                cliffMarketService.updateCustomerGroup(payload.customer, payload.groupName)
                    .then(updateCustomerGroup => {
                        commit('populateUpdateCustomerGroup', updateCustomerGroup);
                        resolve(updateCustomerGroup);
                    })
                    .catch(error => {
                        commit('clearUpdateCustomerGroup');
                        dispatch('alert/error', error, { root: true });
                        reject(error);
                    });
            });
        }
    },
    mutations: {
        clearOrders(state) {
            state.status.listOrdersComplete = false;
            state.orders = [];
        },
        populateOrders(state, orders) {
            state.status.listOrdersComplete = true;
            state.orders = orders;
        },
        clearOrder(state) {
            state.status.getOrderComplete = false;
            state.order = {};
        },
        populateOrder(state, order) {
            state.status.getOrderComplete = true;
            state.order = order;
        },
        clearCustomers(state) {
            state.status.listCustomersComplete = false;
            state.customers = [];
        },
        populateCustomers(state, customers) {
            state.status.listCustomersComplete = true;
            state.customers = customers;
        },
        clearCustomer(state) {
            state.status.getCustomerComplete = false;
            state.customer = {};
        },
        populateCustomer(state, customer) {
            state.status.getCustomerComplete = true;
            state.customer = customer;
        },
        clearUpdateCustomer(state) {
            state.status.updateCustomerComplete = false;
        },
        populateUpdateCustomer(state, updatedCustomer) {
            state.status.updateCustomerComplete = true;
            state.updatedCustomer = updatedCustomer;
        },
        clearUpdatePaymentState(state) {
            state.status.updatePaymentStateComplete = false;
            state.updatePaymentState = null;
        },
        populateUpdatePaymentState(state, updatedPaymentState) {
            state.status.updatePaymentStateComplete = true;
            state.updatePaymentState = updatedPaymentState;
        },
        clearUpdateCustomerGroup(state) {
            state.status.updateCustomerGroupComplete = false;
            state.updateCustomerGroup = null;
        },
        populateUpdateCustomerGroup(state, updateCustomerGroup) {
            state.status.updateCustomerGroupComplete = true;
            state.updateCustomerGroup = updateCustomerGroup;
        }
    }
};
